import React from "react";
import OnBack from "shared/components/SVG/LMF/OnBack";

const Head = ({ description, title, onBack }) => {
  return (
    <div className="lmfHead__area">
      <div className="lmfHead__area--back">
        {onBack && <OnBack onClick={onBack} />}
      </div>
      <div className="lmfHead__area--content">
        <h1 className="lmfHead__area--title">{title}</h1>
        <span
          className="lmfHead__area--description"
          dangerouslySetInnerHTML={{ __html: description }}
        ></span>
      </div>
      <div className="lmfHead__area--right"></div>
    </div>
  );
};

export default Head;
